import util from '@/libs/util'

const post = util.ajax.post
const get = util.ajax.get

export const carUrls = [
  // 查询
  '/recordCar/list',
  // 模糊查询车辆信息
  '/vehicle/querybyplatenumber'
]

export const car = {}

car.listCar = function (params) {
  return post('/vehicle/list', params)
}

car.editCar = function (params) {
  return post('/vehicle/edit', params)
}

car.addCar = function (params) {
  return post('/vehicle/add', params)
}

car.getbyid = function (id) {
  return get(`/vehicle/getbyid?id=${id}`)
}

car.checkPlateNumber = function (params) {
  return post('/vehicle/isexist', params)
}

car.detailCar = function (params) {
  return post('/vehicle/detail', params)
}

car.listOrder = function (params) {
  return post('/order/queryList', params)
}
car.listCarByPlateNumber = function (params) {
  return post('/vehicle/querybyplatenumber', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/record/car.js